module.exports = __webpack_public_path__ + "img/remove.8bac2b3b.svg";